import { Message } from '@patsnap/tahiti-core';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { I18nService } from '@telecom/shared/services/i18n';
import { WireFrameExtractDialogAction } from '../types';
import type { WireFrameExtractMessageService } from '../wire-frame-extract-message-service';

@injectable()
export class WireFrameExtractMessageServiceImpl implements WireFrameExtractMessageService {
    constructor(
        @inject(I18nService)
        private readonly _i18nService: I18nService,
        @inject(Message)
        private readonly _message: Message,
    ) {}

    showSuccessMessage(action: WireFrameExtractDialogAction): void {
        const message = action === WireFrameExtractDialogAction.SAVE_AS
        // cn: 新附图添加成功
        // en: New drawing has been successfully added
        // tw: 新附圖添加成功
        // jp: 新図面が追加されました
            ? this._i18nService.t('wireFrameExtractDialog.success.saveAs')
            : action === WireFrameExtractDialogAction.REPLACE
            // cn: 线框图替换成功
            // en: Wire frame replaced successfully
            // tw: 线框图替换成功
            // jp: 線框図が置き換えられました
                ? this._i18nService.t('wireFrameExtractDialog.success.replace')
                : null;

        if (message) {
            this._message.success({
                message,
            });
        }
    }

    showCountOverLimitError(): void {
        // cn: 无法保存，请移除一张附图后重试
        // en: We were unable to add your drawing. Please remove one of the included images and try again.
        // tw: 無法儲存，請移除一張附圖後重試
        // jp: 保存できません。1枚の図面を削除してから再試してください。
        const message = this._i18nService.t('wireFrameExtractDialog.errors.countOverLimit');
        this._message.error({ message });
    }
}
